/* eslint-disable no-extend-native */
Number.prototype.toCurrencyFormat = function toCurrencyFormat(
  amount: number,
  currency = "TRY"
): string {
  if (Number.isNaN(amount)) {
    throw new Error("amount must be number type");
  }

  return `${amount.toLocaleString("tr", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
};
